export default "__VITE_ASSET__CFSMUSQ9__"